const addHookAction = (type, hook) => {
    return {type, hook};
}

export function addReservationStartHook(hook) {
    return addHookAction("ADD_RESERVATION_START_HOOK", hook);
}

export function addReservationCompleteHook(hook) {
    return addHookAction("ADD_RESERVATION_COMPLETE_HOOK", hook);
}

export function addReservationDataSetHook(hook) {
    return addHookAction("ADD_RESERVATION_DATA_SET_HOOK", hook);
}

export function addListingPriceLevelsUpdateHook(hook) {
  return addHookAction("ADD_LISTING_PRICE_LEVELS_UPDATE_HOOK", hook);
}

export function addReservationClearHook(hook) {
    return addHookAction("ADD_RESERVATION_CLEAR_HOOK", hook);
}

export function addReservationExpiresInHook(hook) {
    return addHookAction("ADD_RESERVATION_EXPIRES_IN_HOOK", hook);
}

export function addStateTransitionHook(hook) {
    return addHookAction("ADD_STATE_TRANSITION_HOOK", hook);
}

export function addGoToCheckoutHook(hook) {
    return addHookAction("ADD_GO_TO_CHECKOUT_HOOK", hook);
}

export function addSetPriceLevelsHook(hook) {
    return addHookAction("ADD_SET_PRICE_LEVELS_HOOK", hook);
}

export function addSetBundlesHook(hook) {
    return addHookAction("ADD_SET_BUNDLES_HOOK", hook);
}

export function addSetProductsHook(hook) {
    return addHookAction("ADD_SET_PRODUCTS_HOOK", hook);
}

export function addCouponSubmissionHook(hook) {
    return addHookAction("ADD_STATE_COUPON_SUBMISSION_HOOK", hook);
}

export function addTicketsAddedToCartHook(hook) {
    return addHookAction("ADD_TICKETS_ADDED_TO_CART_HOOK", hook);
}

export function addProductsAddedToCartHook(hook) {
    return addHookAction("ADD_PRODUCTS_ADDED_TO_CART_HOOK", hook);
}

export function addBundlesAddedToCartHook(hook) {
    return addHookAction("ADD_BUNDLES_ADDED_TO_CART_HOOK", hook);
}

export function addTicketsRemovedFromCartHook(hook) {
    return addHookAction("ADD_TICKETS_REMOVED_FROM_CART_HOOK", hook);
}

export function addProductsRemovedFromCartHook(hook) {
    return addHookAction("ADD_PRODUCTS_REMOVED_FROM_CART_HOOK", hook);
}

export function addBundlesRemovedFromCartHook(hook) {
    return addHookAction("ADD_BUNDLES_REMOVED_FROM_CART_HOOK", hook);
}

export function addTicketIncrementHook(hook) {
    return addHookAction("ADD_TICKET_INCREMENT_HOOK", hook);
}

export function addTicketDecrementHook(hook) {
    return addHookAction("ADD_TICKET_DECREMENT_HOOK", hook);
}

export function addTicketChangeQuantityHook(hook) {
    return addHookAction("ADD_TICKET_CHANGE_QUANTITY_HOOK", hook);
}

export function addProductIncrementHook(hook) {
    return addHookAction("ADD_PRODUCT_INCREMENT_HOOK", hook);
}

export function addProductDecrementHook(hook) {
    return addHookAction("ADD_PRODUCT_DECREMENT_HOOK", hook);
}

export function addProductChangeQuantityHook(hook) {
    return addHookAction("ADD_PRODUCT_CHANGE_QUANTITY_HOOK", hook);
}

export function addBundleIncrementHook(hook) {
    return addHookAction("ADD_BUNDLE_INCREMENT_HOOK", hook);
}

export function addBundleDecrementHook(hook) {
    return addHookAction("ADD_BUNDLE_DECREMENT_HOOK", hook);
}

export function addBundleChangeQuantityHook(hook) {
    return addHookAction("ADD_BUNDLE_CHANGE_QUANTITY_HOOK", hook);
}

export function addInsuranceOptionChangedHook(hook) {
    return addHookAction("ADD_INSURANCE_OPTION_CHANGED_HOOK", hook);
}

export function addCartTimerExtendedHook(hook) {
  return addHookAction("ADD_CART_TIMER_EXTENDED_HOOK", hook);
}

export function addCalendarDateSelectedHook(hook) {
    return addHookAction("ADD_CALENDAR_DATE_SELECTED_HOOK", hook);
}

export function addCalendarTimeSelectedHook(hook) {
    return addHookAction("ADD_CALENDAR_TIME_SELECTED_HOOK", hook);
}

export function addCalendarDateChangedHook(hook) {
    return addHookAction("ADD_CALENDAR_DATE_CHANGED_HOOK", hook);
}

export function addCalendarViewHook(hook) {
    return addHookAction("ADD_CALENDAR_VIEW_HOOK", hook);
}

export function addCheckoutOverlayChangedHook(hook) {
    return addHookAction("ADD_CHECKOUT_OVERLAY_CHANGED_HOOK", hook);
}

export function addMembershipViewHook(hook) {
    return addHookAction("ADD_MEMBERSHIP_VIEW_HOOK", hook);
}

export function addMembershipSuccessSignInHook(hook) {
    return addHookAction("ADD_MEMBERSHIP_SUCCESS_SIGNIN_HOOK", hook);
}

export function addMembershipGoToSignInHook(hook) {
    return addHookAction("ADD_MEMBERSHIP_GO_TO_SIGNIN_HOOK", hook);
}

export function addMembershipSkipSignInHook(hook) {
    return addHookAction("ADD_MEMBERSHIP_SKIP_SIGNIN_HOOK", hook);
}

export function addMembershipSignOutHook(hook) {
    return addHookAction("ADD_MEMBERSHIP_SIGNOUT_HOOK", hook);
}

export function addPersonalDetailsChangedHook(hook) {
    return addHookAction("ADD_PERSONAL_DETAILS_CHANGED_HOOK", hook);
}

export function addContinueShoppingHook(hook) {
    return addHookAction("ADD_CONTINUE_SHOPPING_HOOK", hook);
}

export function addMarketingDisableHook(hook) {
  return addHookAction("ADD_MARKETING_DISABLE_HOOK", hook);
}

export function addRoktEventHook(hook) {
  return addHookAction("ADD_ROKT_EVENT_HOOK", hook);
}
